import { all, takeLatest } from 'redux-saga/effects'
import store from '../../store'
import { actions } from './SystemLabels.slice'
import { paginate } from './SystemLabels.thunk'

function paginateSystemLabels () {
  store.dispatch(paginate() as any)
}

export default function * effects () {
  yield all([
    takeLatest(actions.replaceLimit, paginateSystemLabels),
    takeLatest(actions.replacePage, paginateSystemLabels),
    takeLatest(actions.replaceSearch, paginateSystemLabels),
    takeLatest(actions.replaceLabelableType, paginateSystemLabels),
    takeLatest(actions.replaceSorting, paginateSystemLabels)
  ])
}
